<template>
  <PTCLink
    v-if="resolvedPdfFile?.asset?._ref"
    :class="{
      'inline-flex items-center gap-2': true,
    }"
    :target="target"
    :to="src"
  >
    <slot />
  </PTCLink>
  <slot v-else />
</template>

<script setup lang="ts">
import PTCLink from '~/components/Atmos/PTCLink/PTCLink.vue';
import type { PdfLink } from '~/sanity/types';

const props = defineProps<PdfLink>();

const target = '_blank';

const { lang } = useSiteLang();

const resolvedPdfFile = computed(() =>
  resolveTranslatedPdfFile({ pdfLink: props, lang: lang.value })
);

const src = computed((): string => {
  const pdfRef = resolvedPdfFile.value?.asset?._ref;
  if (!pdfRef) {
    console.warn('No PDF file provided to PDFLink', JSON.stringify(props));
    return '#';
  }
  const resolvedSrc = cdnFileSrcFromAssetRef(pdfRef);
  if (!resolvedSrc) {
    console.warn('Invalid PDF file reference:', pdfRef);
    return '#';
  }
  return resolvedSrc;
});
</script>

<style scoped></style>
